<template>
  <div>
    <div class="text-left mb-2">
      <span>Line 1</span>
      <input
        v-model="line1"
        @focus="handleFocus('line1')"
        @blur="handleBlur"
        type="text"
        placeholder="Enter Line 1"
        class="form-control"
      />
      <validation-message v-if="validator.line1" :message="validator.line1"/>
    </div>

    <div class="text-left mb-2">
      <span>Line 2 <span class="small text-muted">(optional)</span></span>
      <input v-model="line2" @blur="handleBlur" type="text" class="form-control"/>
    </div>

    <div class="text-left mb-2">
      <span>Line 3 <span class="small text-muted">(optional)</span></span>
      <input v-model="line3" @blur="handleBlur" type="text" class="form-control"/>
    </div>

    <div class="text-left mb-2">
      <span>Town <span class="small text-muted">(optional)</span></span>
      <input v-model="town" @blur="handleBlur" type="text" class="form-control"/>
    </div>

    <div class="text-left mb-2">
      <span>County <span class="small text-muted">(optional)</span></span>
      <input v-model="county" @blur="handleBlur" type="text" class="form-control"/>
    </div>

    <div class="text-left mb-2">
      <span>Postcode</span>
      <input
        v-model="postCode"
        @focus="handleFocus('postCode')"
        @blur="handleBlur"
        type="text"
        placeholder="Enter Postcode"
        class="form-control"
      />
      <validation-message v-if="validator.postCode" :message="validator.postCode"/>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { AddressHelper } from '@/helpers/AddressHelper'
import { StatusEmitterMixin } from '@/mixins/GeneralRegistration/StatusEmitterMixin'
import ValidationMessage from '@/components/ErrorValidation/ValidationMessage.vue'

export default {
  name: 'ClientAddressFieldManualInput',
  mixins: [StatusEmitterMixin],
  data () {
    return {
      line1: '',
      line2: '',
      line3: '',
      town: '',
      county: '',
      postCode: '',
      validator: AddressHelper.getAddressValidator(),
      requiredFocused: {
        line1: false,
        postCode: false
      }
    }
  },
  computed: {
    ...mapState('ApplicationEvents', [
      'saveClientRegistrationEvent'
    ]),
    ...mapState('ClientRegistrationUpload', [
      'address'
    ]),
    addressModel () {
      return {
        line1: this.line1,
        line2: this.line2,
        line3: this.line3,
        town: this.town,
        county: this.county,
        postCode: this.postCode
      }
    },
    allRequiredFocused () {
      return this.requiredFocused.line1 && this.requiredFocused.postCode
    },
    validated () {
      return !!this.validator.isValid
    }
  },
  watch: {
    saveClientRegistrationEvent () {
      this.validate()
    },
    address: {
      immediate: true,
      deep: true,
      handler (value) {
        this.setAddress(value)
      }
    }
  },
  methods: {
    ...mapMutations('ClientRegistrationUpload', [
      'setClientAddressLines'
    ]),
    handleFocus (field) {
      if (field in this.requiredFocused) {
        this.requiredFocused[field] = true
      }
    },
    handleBlur () {
      this.setClientAddressLines(this.addressModel)
      if (this.allRequiredFocused) {
        this.validate()
      }
    },
    setAddress (value) {
      this.line1 = value?.line1 || ''
      this.line2 = value?.line2 || ''
      this.line3 = value?.line3 || ''
      this.town = value?.town || ''
      this.county = value?.county || ''
      this.postCode = value?.postCode || ''
    },
    validate () {
      this.validator.check(this.addressModel)
    }
  },
  components: {
    'validation-message': ValidationMessage
  }
}
</script>
